import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { TechnicalDocumentationService } from './technical-documentation.service';

import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { HandleError } from '../../core/models/handle-error';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { NgIf, NgFor, NgClass, NgStyle } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchFilterPipe } from '../../shared/pipes/search-filter.pipe';

@Component({
    selector: 'app-technical-documentation',
    templateUrl: './technical-documentation.component.html',
    styleUrls: ['./technical-documentation.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgFor,
        NgClass,
        NgStyle,
        FormsModule,
        SearchFilterPipe,
    ],
})
export class TechnicalDocumentationComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  private subscription: ISubscription[];
  public isShowAll = false;
  public isShowNew = false;
  public isShowHistory = false;
  public techDocs: any;
  public categoriesSorted: any;
  public docTitle: string;
  public techDocContentObject: any;
  public newDocsCount: number;
  public expandTechDoc = {};
  public serviceError = 'Loading data. Please wait...';
  APP_SETTINGS: any;
  public search4techDocs;
  username: string;

  errorMessage: string;


  constructor(
    private changeDetector: ChangeDetectorRef,
    private utilityService: UtilityService,
    private techDocService: TechnicalDocumentationService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private analyticsService: AnalyticsService,
    private userProfileService: UserProfileService,
    private router: ActivatedRoute
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    this.subscription = [];
    if (APP_SETTINGS.techDocument == 'all') { this.showAll(); }
    if (APP_SETTINGS.techDocument == 'new') { this.showNew(); }
    if (APP_SETTINGS.techDocument == 'history') { this.showHistory(); }
    this.techDocs = [];
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  showAll() {
    this.isShowAll = true;
    this.isShowNew = false;
    this.isShowHistory = false;
    this.errorMessage = '';
    APP_SETTINGS.techDocument = 'all';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.techDocService.getTechDocsAll().subscribe(data => {
      
      this.techDocs = data['content'];
      this.categoriesSorted = this.techDocs.map(a => a.title);
      this.categoriesSorted.sort((a, b) => a.localeCompare(b, undefined, {sensitivity: 'base'}));
      
      let myArr = [];
      this.categoriesSorted.forEach((value, index, array) => {
        let subCatArray = [];  
        this.techDocs.forEach((sub, index, array) => {
          if(sub.title.toUpperCase() == value.toUpperCase()) {
            sub.content.forEach((value, index, array) => {
              subCatArray.push(value);
            });
          }
        });
        myArr.push({title:value, content: subCatArray, isOpen: false});
      });
      
      this.techDocs = myArr;

      this.newDocsCount = data['newSize'];
      // get 1st object on loading and user hasn't made any selection yet
      this.techDocs[0].isOpen = true;
      this.techDocContentObject = this.techDocs[0]['content'];
      this.docTitle = this.techDocs[0]['title'];
      this.changeDetector.detectChanges();
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }

  showNew() {
    this.isShowAll = false;
    this.isShowNew = true;
    this.isShowHistory = false;
    this.errorMessage = '';
    APP_SETTINGS.techDocument = 'new';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.techDocService.getTechDocsNew().subscribe((data: Array<any>) => {
      if (data && data.length !== 0) {
        this.techDocs = data;
        this.docTitle = data[0]['title'];
        this.techDocContentObject = data[0]['content'];
        this.changeDetector.detectChanges();
      } else {
        this.techDocs = [];
        this.docTitle = '';
        this.techDocContentObject = [];
        this.errorMessage = 'No New Technical Documents';
      }
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showHistory() {
    this.isShowAll = false;
    this.isShowNew = false;
    this.isShowHistory = true;
    this.errorMessage = '';
    APP_SETTINGS.techDocument = 'history';
    this.spinnerService.show('bmwSpinner');
    this.subscription.push(this.techDocService.getUserTechDocHistory(this.username).subscribe((data: Array<any>) => {
      if (data && data.length !== 0) {
        this.techDocs = data;
        this.docTitle = data[0]['title'];
        this.techDocContentObject = data[0]['content'];
        this.changeDetector.detectChanges();
      } else {
        this.techDocs = [];
        this.docTitle = '';
        this.techDocContentObject = [];
        this.errorMessage = 'No History Found';
      }
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  loadDocContent(docObject) {
    this.docTitle = docObject.title;
    this.techDocs.forEach((value, index, array) => {
      if(value.title !== docObject.title)
        value.isOpen = false;
    });
    docObject.isOpen = !docObject.isOpen;
    this.techDocContentObject = docObject['content'];
  }
  loadSubDocContent(docObject, subDocObject) {
    this.docTitle = docObject.title;
    this.techDocContentObject = [subDocObject];
  }
  saveToHistory(docId, documentTitle) {
    //Analytics Call
    if (APP_SETTINGS.isAdmin === 'true') {
      this.analyticsService.trackClicksbyAdminUser('Technical Documentation', documentTitle, this.username);
    }
    else {
      this.analyticsService.trackClicksByDocumentsContentTypeLineMake('Technical Documentation', documentTitle);
    }
    if (APP_SETTINGS.isExternal === 'true') {
      this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
        this.analyticsService.trackClicksByExternalContentType('Technical Documentation', documentTitle, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
      });
    }
    if (APP_SETTINGS.isDealer === 'true') {
      this.analyticsService.trackDealerContentTypeLocation('Technical Documentation', documentTitle, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
        APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
    }
    this.subscription.push(this.techDocService.postUserTechDocHistory(this.username, docId).subscribe(value => {
      if (value) {
      }
    }));
  }
  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

}
